import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Divider.module.scss';

const Divider = ({ className }) => (
  <div className={classnames(styles.root, className)} />
);

Divider.propTypes = {
  className: PropTypes.string,
};

Divider.defaultProps = {
  className: null,
};
export { Divider };
